import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Row } from '../server/layout/Row/index';
import { Stack } from '../server/layout/Stack/index';
import { Skeleton } from '../server/state/Skeleton/Skeleton';
const NAME_HEIGHT = { 32: 13, 36: 14, 44: 15 };
export function PersonRowSkeleton({ avatarSize = 36 }) {
    const nameH = NAME_HEIGHT[avatarSize];
    return (_jsxs(Row, { gap: "md", align: "center", style: { minWidth: 0 }, children: [_jsx(Skeleton, { width: avatarSize, height: avatarSize, rounded: "full", style: { flexShrink: 0 } }), _jsxs(Stack, { gap: "sm", style: { flex: 1, minWidth: 0 }, children: [_jsx(Skeleton, { width: "72%", height: nameH, rounded: "sm" }), _jsx(Skeleton, { width: "48%", height: 13, rounded: "sm" })] })] }));
}
//# sourceMappingURL=PersonRow.skeleton.js.map